export type PostMeta = {
  slug: string;
  title: string;
  date: string; // ISO or readable string
  excerpt: string;
};

// Add posts here
export const posts: PostMeta[] = [
  {
    slug: "brewing-code-and-coffee-part-2",
    title: "Brewing Code & Coffee – Part 2",
    date: "2025-07-10",
    excerpt: "Building Daily Drip—a PWA espresso recipe app—rekindled my love for coding through animations, bug-fixes, and small wins.",
  },
  {
    slug: "falling-back-in-love-with-coding-part-1",
    title: "Falling Back in Love with Coding – Part 1",
    date: "2025-07-01",
    excerpt: "Reclaiming confidence and enthusiasm for coding when AI takes the wheel.",
  },
  {
    slug: "hello-world",
    title: "Hello World",
    date: "2024-07-01",
    excerpt: "Kickstarting the blog with a brief introduction and what to expect.",
  },
]; 